module.exports = __webpack_public_path__ + "static/media/manage_departments_delete_department.0887b5ed.mov";